import { MaterializeAction } from 'angular2-materialize';
import { DomSanitizer } from '@angular/platform-browser';
import {
    Component,
    Input,
    Output,
    EventEmitter,
    ViewChild,
    ElementRef,
    OnInit,
    OnChanges,
    SimpleChanges,
    AfterViewInit,
    OnDestroy,
} from '@angular/core';
import { Router } from '@angular/router';
import { ModalService } from "../shared/helper-components/modal/_services/modal.service";
import { ModalPromptService } from '../shared/helper-components/modal-prompt.service';
import { ISubscription } from "rxjs/Subscription";
import { AppService } from '../app.service';
import { ClearanceItemImageService } from './clearance-item-image.service';
import { ClearanceItemService } from './clearance-item.service';
import { AppUtils, SharedUtils } from '../shared/utils';
import { CIAsset, CIImage, ClearanceItem } from './clearance-item.model';
import { NotificationsService, Notification } from '../shared/helper-components';
import { GlobalErrorHandler } from '../shared/core/error-handler';
import * as FileSaver from 'file-saver';
import { ILookup } from '../shared/lookup';
import { AuthService } from '../shared/core/index';
import { SnP_STATUSES } from '../shared/helper-components/constants';
declare var $: any; 
@Component({
    selector: 'carousel',
    template: require('./carousel.component.html'),
    styles: [require('./carousel.component.css')],
})
export class CarouselComponent implements OnChanges, AfterViewInit, OnDestroy {
    @Input() index: number = 0;
    @Input() images;
    @Input() projectId: string;
    @Input() showSpinner;
    @Input() loop : Boolean=true;
    @Input() hideReportDefaultIcons : Boolean;
    @Input() dataImages = [];
    @Input() preventRemoval;
    @Input() itemList: ClearanceItem[] = [];
    @Input() currentCI: ClearanceItem;
    @Input() currentCiName: string;
    @Input() statusLookup: ILookup[] = [];
    @Input() currentCiStatus: string;
    @Input() currentCiStatusComments: string;
    @Input() projectDepartment: string;
    @Output() onSetDefault: EventEmitter<any> = new EventEmitter();
    @Output() onShowOnReport: EventEmitter<any> = new EventEmitter();
    @Output() onDownload: EventEmitter<any> = new EventEmitter();
    @Output() onRemoveAsset: EventEmitter<any> = new EventEmitter();
    @Output() onClose: EventEmitter<any> = new EventEmitter();
    @Output() onCIStatusChanged: EventEmitter<any> = new EventEmitter();
    @Output() onSaveDetails: EventEmitter<any> = new EventEmitter();
    @Output() onDeleteAnnotatedImage: EventEmitter<any> = new EventEmitter();
    @Output() onDeleteMainImage: EventEmitter<any> = new EventEmitter();
    @Output() initialized = new EventEmitter<CarouselComponent>();
    @Input() ciListQueryString: string;

    @ViewChild('divImage') divImage: ElementRef;
    @ViewChild('divPanel') divPanel: ElementRef;
    @ViewChild('divContainer') divContainer: ElementRef;
    @ViewChild('imgFont') imgFont: ElementRef; 
    @ViewChild('imgUsage') imgUsage: ElementRef; 
    @ViewChild('imgNotes') imgNotes: ElementRef; 
    @ViewChild('snpStatusComments') snpStatusComments: ElementRef; 
    @ViewChild('divButtons') divButtons: ElementRef; 
    imageIsLoaded: Boolean = false;
    currentIndex: number=0;
    currentCiIndex: number=0;
    currentCiId: string;
    promptSubscription: ISubscription;
    currentFullImageUrl: any;
    currentImageName: string;
    currentFont: string;
    currentTag: string;
    currentUsage: string;
    currentNotes: string;
    currentComments: string;
    currentSnpStatusComments: string;
    transition: boolean = false;
    delayTime: number=0;
    panelVisible: boolean = false;
    enableActionButtons: boolean = false;
    fileIsImage: boolean = false;
    fileIsPDF: boolean = false;
    originalCiStatus: string;
    originalCiStatusComments: string;
    loadingCI: boolean = false;
    loadingImage: boolean = false;
    savingCI: boolean = false;
    currentRelatedImages: CIImage[];
    originalImage: any;
    currentAnnotatedImageDisplayedIndex: number = -1;
    displayRetrievingImage: boolean = false;
    currentImageKey: string = '';
    secondaryStatuses = Array.from(SnP_STATUSES);

    private observer: MutationObserver;

    constructor(
        private modalService: ModalService,
        private _prompt: ModalPromptService,
        private _appService: AppService,
        private _clearanceItemImageService: ClearanceItemImageService,
        private _clearanceItemService: ClearanceItemService,
        private _notificationsService: NotificationsService,
        private _errorHandler: GlobalErrorHandler,
        private router: Router,
        private domSanitizer: DomSanitizer,
        private _authService: AuthService,
    ) {
        this.modalService.subscribeToModalOpenClose().subscribe(action => {
            if (!action){
                this.imageIsLoaded = false;
            }
        });
    }

    ngOnInit() {
        this.initialized.emit(this);
    }

    ngOnDestroy(): void {
        if (this.observer) {
            this.observer.disconnect();
          }
        URL.revokeObjectURL(this.currentFullImageUrl);
    }

    ngOnChanges(){
        this.currentIndex = this.index;
        this.imageIsLoaded = true;
        this.setCurrentImageUrl();
        this.setImageNotes();
        this.transition = false;
        this.originalCiStatus = this.currentCiStatus;
        this.originalCiStatusComments = this.currentCiStatusComments;
        this.changeStatus(this.currentCiStatus, this.currentCiStatusComments);
        this.setCurrentRelatedImages();
    }

    ngAfterViewInit() {
        $('#statusSelect').material_select();

        this.observer = new MutationObserver(() => {
            this.applySelectStatusStyles();
          });

        this.observer.observe(document.querySelector('.container-carousel'), {
            childList: true,
            subtree: true,
          });

        this.applySelectStatusStyles();
          setTimeout(() => {
            if (!this.panelVisible && (this.images[this.currentIndex].relatedImages.length > 0 || this.images[this.currentIndex].notes !== null)){               
                this.setPanelVisible(null);
            }
            this.changeStatus(this.currentCiStatus, this.currentCiStatusComments);
          });
        
      }
    goToNext(): void {
        const isLastImage = this.currentIndex === this.images.length - 1;
        if (!isLastImage || this.loop)
        {
            const newIndex = isLastImage ? 0 : this.currentIndex + 1;
            this.currentIndex = newIndex;
        }
        this.currentAnnotatedImageDisplayedIndex = -1;
    }

    goToPrevious(): void {
        const isFirstImage = this.currentIndex === 0;
        if (!isFirstImage || this.loop)
        {
            const newIndex = isFirstImage ?  this.images.length - 1 : this.currentIndex - 1;
            this.currentIndex = newIndex;
        }
        this.currentAnnotatedImageDisplayedIndex = -1;
    }

    transitionDelay(time) {
        return new Promise(resolve => setTimeout(resolve, time));
    }

    setCurrentRelatedImages(): void {
        if (this.images[this.currentIndex].relatedImages){
            this.currentRelatedImages = this.images[this.currentIndex].relatedImages;
            this.originalImage = {...this.images[this.currentIndex]};
        }
    }

    setCurrentImageUrl(): void {
        this.setImageNotes();
        this.transition = true;
        this.showSpinner = true;
        this.displayRetrievingImage=false;
        this.setNewImageKey();
        URL.revokeObjectURL(this.currentFullImageUrl);


        this.fileIsImage = SharedUtils.FileTypeIsImage(this.images[this.currentIndex].fileType);
        this.fileIsPDF = this.images[this.currentIndex].fileType.endsWith('pdf');
        if (!this.images[this.currentIndex].originalImageFullUrl && this.fileIsImage){
            this.images[this.currentIndex].originalImageFullUrl = this.getImageData(this.images[this.currentIndex].url);
        }
        if (this.currentFullImageUrl == this.images[this.currentIndex].originalImageFullUrl && this.fileIsImage){
            this.setImageLoaded();
            this.setCurrentImageName(this.images[this.currentIndex].name);
            return;
        }
        this.currentFullImageUrl = null;
        this.currentImageName="";
        
        if (!this.images[this.currentIndex].originalImageFullUrl && (this.fileIsImage || this.fileIsPDF)){
            this.images[this.currentIndex].originalImageFullUrl = this.getImageData(this.images[this.currentIndex].url);
        }
        if (!this.images[this.currentIndex].originalImageFullUrl && (this.fileIsImage || this.fileIsPDF)){
            this._appService.getSignedUrl(this.images[this.currentIndex].url, this.projectId,'GET','image','ci',this.images[this.currentIndex].urlName)
            .subscribe((data) => {
                this.images[this.currentIndex].originalImageFullUrl = data.url;
                this.currentFullImageUrl = data.url;
                this.setCurrentImageName(this.images[this.currentIndex].name);
            });
        }
        else{
            if (this.fileIsImage && this.images[this.currentIndex].originalImageFullUrl.startsWith('data:image')){
                this.delayTime = Math.ceil(this.images[this.currentIndex].originalImageFullUrl.length/2000000/10)*50;
            }
            if (this.images[this.currentIndex].fileType.endsWith('pdf')){
                this.currentFullImageUrl="../../assets/images/PDF_file_icon.png"
            }
            else if (!SharedUtils.FileTypeIsImage(this.images[this.currentIndex].fileType)){
                this.currentFullImageUrl="../../assets/images/attachment-icon.jpg"
                this.setImageLoaded();
            }
            else{

                if (this.images[this.currentIndex].mediumImageFullUrl === "" ){
                    this.currentFullImageUrl = this.images[this.currentIndex].originalImageFullUrl;
                }
                else{
                    this.currentFullImageUrl = this.images[this.currentIndex].mediumImageFullUrl;  
                    this.preloadAndSetImage(this.images[this.currentIndex].originalImageFullUrl);
                }
            }

            this.setCurrentImageName(this.images[this.currentIndex].name);
            if (this.images[this.currentIndex].name.endsWith('.pdf')){
                this.setImageLoaded();
            }
        }   
    }

    setCurrentImageName(imageName: string){
        if(this.currentAnnotatedImageDisplayedIndex != -1){
            this.currentImageName = `${imageName} - Annotation ${this.currentAnnotatedImageDisplayedIndex + 1}`;
        }else{
            this.currentImageName = imageName;
        }
    }

    setImageLoaded() {
        var parent = this;
        this.transitionDelay(this.delayTime).then(() => {
            parent.imageIsLoaded = true;
            parent.showSpinner = false;
            parent.transition = false;
        });
    }

    closeModal(id: string){
        this.imageIsLoaded = false;
        this.panelVisible = false
        this.setPanelVisible(this.currentIndex);
        if (this.modalService.modalExists('image-modal-carousel')){
            this.modalService.close(id);
        }
        this.onClose.emit(id);
    }

    setDefaultCurrentItem(event){
        let currentState = this.images[this.currentIndex].defaultC;
        this.images.forEach(image => {
            image.defaultC = false;
        });

        this.images[this.currentIndex].defaultC=!currentState;
        this.onSetDefault.emit(event.id);
    }

    showItemOnReport(event){
        let currentState = this.images[this.currentIndex].showOnReports;
        this.images[this.currentIndex].showOnReports=!currentState;
        this.onShowOnReport.emit(event.id);
    }

    saveImage(event){
        if (this.currentAnnotatedImageDisplayedIndex == -1){
            this.getDirectDownload(this.images[this.currentIndex]);
            return;
        }
        this.getDirectDownload(this.images[this.currentIndex].relatedImages[this.currentAnnotatedImageDisplayedIndex]);

     }

    removeImage(){
        let preventDeleteMessage = 'Are you sure you want to remove this annotated image?'
        if (this.currentAnnotatedImageDisplayedIndex == -1){
            preventDeleteMessage = 'Are you sure you want to remove the image and ALL annotated images related to this image?'
        }


        this.promptSubscription = this._prompt.openModal(
            this.removeCurrentItem.bind(this), true, {header: 'Please Confirm', body: preventDeleteMessage}).first().subscribe(r=>{
        });
    }

    removeCurrentItem(){
        if (this.currentAnnotatedImageDisplayedIndex != -1){
            let annotatedIndex = this.currentAnnotatedImageDisplayedIndex;
            this.DeleteAnnotatedImage(annotatedIndex);
            this.images[this.currentIndex].relatedImages.splice(annotatedIndex,1);
            if (this.images[this.currentIndex].relatedImages.length>0){
                this.currentAnnotatedImageDisplayedIndex = annotatedIndex === 0 ? this.currentAnnotatedImageDisplayedIndex : this.currentAnnotatedImageDisplayedIndex - 1;
                this.setAnnotatedImageOnCarousel(this.images[this.currentIndex].relatedImages[this.currentAnnotatedImageDisplayedIndex].originalFullUrl, this.currentAnnotatedImageDisplayedIndex);
                return;
            }
            this.currentAnnotatedImageDisplayedIndex = -1;
            this.setAnnotatedImageOnCarousel(this.currentFullImageUrl, -1);
            this.setCurrentImageUrl();            
            this.setCurrentRelatedImages();
            return;
        }
        let index = this.currentIndex;
        this.DeleteMainImage(index);
    }

    openImage(){
        window.open(this.images[this.currentIndex].originalImageFullUrl);
    }

    getImageData(url){
        var img = this.dataImages.find((data)=>{
            return data.name == url;
        });
        if (img){
            return img.imageData;
        }
    }

    openAnnotationTool(){
        this.imageIsLoaded = false;
        this.modalService.close('image-modal-carousel');
        let imageUrl = this.images[this.currentIndex].url;
        if (this.currentAnnotatedImageDisplayedIndex >= 0){
            imageUrl = this.images[this.currentIndex].relatedImages[this.currentAnnotatedImageDisplayedIndex].url;
        }

        if (this.itemList.length>0){
            let queryString = this.ciListQueryString.split('&ciId')[0];
            this.router.navigate(['/docviewer', encodeURIComponent(imageUrl), this.images[this.currentIndex].name, this.projectId, this.images[this.currentIndex].cIId, this.images[this.currentIndex].assetType, this.currentIndex, 'ciList',encodeURIComponent(queryString)]);
        }
        else{
            this.router.navigate(['/docviewer', encodeURIComponent(imageUrl), this.images[this.currentIndex].name, this.projectId, this.images[this.currentIndex].cIId, this.images[this.currentIndex].assetType, this.currentIndex, 'ciDetail','']);
        }
    }

    stopPropagation(event: Event) {
        event.stopPropagation();
    }

    setPanelVisible(event){
        this.panelVisible = !this.panelVisible;

        const divContainer = this.divContainer.nativeElement;
        const divImage = this.divImage.nativeElement;
        const divPanel = this.divPanel.nativeElement;
        const divButtons = this.divButtons.nativeElement;
        
        divImage.style["transition-duration"] ="0s";
        if (this.panelVisible){
            divPanel.style["width"]="20%";
            divPanel.style["display"]="unset";
            divImage.style["width"]="80%";
        }
        else
        {
            divPanel.style["width"]="0%";
            divPanel.style["display"]="none";
            divImage.style["width"]="100%";
        }

        setTimeout(() => {
            const divImage = this.divImage.nativeElement;
            divImage.style["transition-duration"] = '2s';
          }, 0);
    }

    setImageNotes(){
        if(this.images[this.currentIndex].comments){
            const comments = JSON.parse(this.images[this.currentIndex].comments);

            this.currentComments = comments
            .map(comment => `${comment.text}\n${new Date(comment.creationTime).toLocaleString()}\n`)
            .join("\n");
        }else{
            this.currentComments = "";
        }

        this.currentFont = this.images[this.currentIndex].font;
        this.currentUsage = this.images[this.currentIndex].usage;
        if (this.images[this.currentIndex].tag)
            this.currentTag = this.images[this.currentIndex].tag.split(',').filter(t=>t.trim()).join(',');
        else
            this.currentTag = "";

        if (this.currentAnnotatedImageDisplayedIndex >= 0)
            this.currentNotes = this.images[this.currentIndex].relatedImages[this.currentAnnotatedImageDisplayedIndex].notes;
        else
            this.currentNotes = this.images[this.currentIndex].notes;
        this.enableActionButtons=false;
    }

    saveImageNotes(){
        if (this._authService.secondApproval){
            return;
        }
        this.savingCI = true;
        var ciImage: CIImage;
        if (this.currentAnnotatedImageDisplayedIndex >= 0){
            ciImage = this.images[this.currentIndex].relatedImages[this.currentAnnotatedImageDisplayedIndex];
            ciImage.notes = this.imgNotes.nativeElement.value;
        }
        else{
            ciImage = this.images[this.currentIndex];
            ciImage.font = this.imgFont.nativeElement.value;
            ciImage.usage = this.imgUsage.nativeElement.value;
            ciImage.notes = this.imgNotes.nativeElement.value;
        }

        let someImageHasNotes = this.images.some(img => img.notes !== null && img.notes !== "");
        let someAnnotatedImageHasNotes = this.images.some(img => img.relatedImages.some(ri => ri.notes !== null && ri.notes !== ""));
        let itemHasNotes = someImageHasNotes || someAnnotatedImageHasNotes;

        let fonts = this.images
            .filter(img => img.font !== null && img.font !== "")
            .map(img => img.font)
            .join(',');

        this._clearanceItemImageService.patchImageNotes(ciImage)
            .subscribe(img => {
                this.enableActionButtons=false;
                this._notificationsService.add(new Notification('success', 'Image details were updated successfully'));
                this.onSaveDetails.emit({ciImage : ciImage, itemHasNotes : itemHasNotes, fonts : fonts});
                this.savingCI=false;
            },
        (error: any) => {
            var e = JSON.stringify(error);
            if(e.indexOf("AntiXssMiddleware") !== -1 || error.includes("AntiXssMiddleware")){
              this._notificationsService.add(new Notification('error', this._errorHandler.xssMessage));                     
            }else{
              this._errorHandler.processError(error);
            }
            this.savingCI=false;
            console.error(error);
        } );
    }

    undoImageNotes(){
        if (this._authService.secondApproval){
            this.enableActionButtons=false;
            return;
        }
        this.setImageNotes();
    }


    onAnyNotesChanged(event: Event){
        this.enableActionButtons=true;
    }

    onImageModalDivClick(event: Event) {
        event.stopPropagation();
      }

    getDirectDownload(item) {
        this.showSpinner = true;
        var projectId = item.url.split('/')[2];
        var ownerType = "ci";
        this._appService.getSignedUrl(encodeURIComponent(item.url), projectId, 'GET', 'image', ownerType, encodeURIComponent(item.name))
        .subscribe(signedUrl => {
            let downloadedAsset = Object.assign(new CIAsset(), item);
            downloadedAsset.fullUrl = signedUrl.url;
            downloadedAsset.name = item.name;
            console.log('ImageProcessing.downloadAsset >> signed Url:' + signedUrl.url);
            this.downloadAsset(downloadedAsset);
        });
    }

    downloadAsset(item) {
        this._appService.getFileAs(item).subscribe(f=>{
            FileSaver.saveAs(f, item.name);
            this.showSpinner = false;
        });
    }

    goToNextCI(): void {
        this.loadingCI = true;
        this.currentImageName = "";
        this.currentCiName = "";
        this.transition = true;
        this.showSpinner = true;
        this.currentCiId = this.images[this.currentIndex].cIId;
        this.currentCiIndex = this.itemList.findIndex(ci => ci.id == this.currentCiId); 
        this.currentCiIndex = (this.currentCiIndex + 1) % this.itemList.length;
        this.currentAnnotatedImageDisplayedIndex = -1;
        while (this.itemList[this.currentCiIndex].images.filter(i => i.assetType == "Image").length == 0){
            this.currentCiIndex = (this.currentCiIndex + 1) % this.itemList.length;
        }
        this.openCI(this.itemList[this.currentCiIndex]);
    }

    goToPreviousCI(): void {
        this.loadingCI = true;
        this.currentImageName = "";
        this.currentCiName = "";
        this.transition = true;
        this.showSpinner = true;
        this.currentCiId = this.images[this.currentIndex].cIId;
        this.currentCiIndex = this.itemList.findIndex(ci => ci.id == this.currentCiId); 
        this.currentCiIndex = (this.currentCiIndex - 1 + this.itemList.length) % this.itemList.length;
        this.currentAnnotatedImageDisplayedIndex = -1;
        while (this.itemList[this.currentCiIndex].images.filter(i => i.assetType == "Image").length == 0){
            this.currentCiIndex = (this.currentCiIndex - 1 + this.itemList.length) % this.itemList.length;
        }
        this.openCI(this.itemList[this.currentCiIndex]);
    }

    

    openCI(item: ClearanceItem){
        var parent = this;
        this._clearanceItemService.getCI(item.id, true)
            .subscribe
            (
                (data) => {
                    parent.onCIRetrieved(data);
                    var default_index = parent.images.findIndex(img => img.url == item.images[0].url);
                    parent.currentIndex = default_index;
                    this.setCurrentImageUrl();
                    this.setCurrentRelatedImages();
                }
            )
    }

    onCIRetrieved(ci: ClearanceItem): void {
        if (ci) {
            this.images = [];
            this.currentIndex = 0;
            this.showSpinner=false;
            this.currentCiName = ci.name;
            this.originalCiStatus = ci.status;
            this.originalCiStatusComments = ci.statusChangeComments;
            this.loadingCI = false;
            this.changeStatus(ci.status, ci.statusChangeComments);
            var ciImages = ci.images;

            if (ciImages && ciImages.length > 0){
                ciImages.forEach(img => {
                    if (img.assetType=="Image"){
                        img.originalImageFullUrl = img.fullUrl;
                        this.images.push(img);
                    }    
                });
            }
        }
    }

    undoStatusChange(){
        this.changeStatus(this.originalCiStatus, this.originalCiStatusComments);
    }

    saveStatusChange(){
        this.showSpinner  = true;
        this.savingCI = true;
        this.currentCiId = this.images[this.currentIndex].cIId;
        let statusChangeComments = '';
        if (this._authService.secondApproval && (this.currentCiStatus === 'DEFERRED' || this.currentCiStatus === 'DENIED')) {
            statusChangeComments = this.snpStatusComments.nativeElement.value;    
        }
        this.ciStatusChange({ciId: this.currentCiId, ciStatus: this.currentCiStatus, statusChangeComments: statusChangeComments});
    }
    updateMaterializeSelect() {
        this.changeStatus(this.currentCiStatus, this.currentCiStatusComments);
      }

    changeStatus(newStatus: string, newStatusComments: string) {
        this.currentCiStatus = newStatus;
        this.currentCiStatusComments = newStatusComments;
        if (!this.snpStatusComments)
            return;

        if (this._authService.secondApproval) {
            this.snpStatusComments.nativeElement.value = this.currentCiStatusComments;
        }
    }

    ciStatusChange($event){
        let parent = this;
        let itemToSave = this.currentCI;
        if (this.itemList.length>0){
            itemToSave = this.itemList.find(ci => ci.id == $event.ciId)
        }
        itemToSave.status = $event.ciStatus;
        itemToSave.statusChangeComments = $event.statusChangeComments;

            this._clearanceItemService.saveClearanceItemStatus(itemToSave)
            .subscribe(ci => {
                this.onClearanceItemSaved(ci);
                if (this._authService.secondApproval ) {
                    parent.originalCiStatus = this.currentCiStatus;
                    parent.originalCiStatusComments = '';
                    parent.currentCiStatusComments = '';
                    if (parent.currentCiStatus === 'DEFERRED' || parent.currentCiStatus === 'DENIED') {
                        parent.originalCiStatusComments = parent.snpStatusComments.nativeElement.value
                        parent.currentCiStatusComments = parent.snpStatusComments.nativeElement.value
                    }
                }
            },
                err => {
                    this.savingCI = false;
                    var e = JSON.stringify(err);

                    if(e.indexOf("AntiXssMiddleware") !== -1 || err.includes("AntiXssMiddleware")){
                        this._notificationsService.add(new Notification('error', this._errorHandler.xssMessage));
                        this.showSpinner = false;
                    }
                    else{
                        this.showSpinner = false;
                        this._errorHandler.processError(err);
                    }
                });
    }

    onClearanceItemSaved(ci: ClearanceItem) {
        this.showSpinner  = false;
        this.savingCI = false;
        if (ci && ci.id) {
            this._notificationsService.add(new Notification('success', 'Clearance Item saved successfully.'));
            this.currentCiStatus = ci.status;
            this.originalCiStatus = ci.status;
            this.enableActionButtons = false;
            this.onCIStatusChanged.emit({ciId: this.currentCiId, ciStatus: this.currentCiStatus})
        }
        else {
            this._notificationsService.add(new Notification('error', 'Failed to save Clearance Item, Please try again later.'));
        }
    }

    private applySelectStatusStyles() {
        if (this._authService.readOnly) {
            $('.container-carousel .select-wrapper').css('color', 'white');
            $('.container-carousel .select-wrapper .caret').css('color', 'white');    
            $('.container-carousel .select-wrapper .select-dropdown').css('color', 'white');    
            $('.container-carousel .select-wrapper .select-dropdown').css('border-bottom-color', 'white');    
            return;
        }
        $('.container-carousel .select-wrapper').css('color', 'white');
        $('.container-carousel .select-wrapper .caret').css('color', 'white');
    }

    openImageInNewTab(event: MouseEvent, imageUrl: string, index: number): void {
        event.preventDefault();
        this.setAnnotatedImageOnCarousel(imageUrl, index);
    }

    setAnnotatedImageOnCarousel(annotatedImageUrl: string, annotatedImageIndex: number) {
        this.currentAnnotatedImageDisplayedIndex = annotatedImageIndex
        this.currentFullImageUrl = null;
        this.showSpinner = true;
        if (annotatedImageUrl.startsWith("data:image") ){ 
            this.currentFullImageUrl = annotatedImageUrl;
            return;
        }
        this.getImageBytes(annotatedImageUrl).then((data) => {
            this.currentFullImageUrl = data;    
        })
        .catch((error) => {
            console.log(error);
        });
    }


    getImageBytes(imageUrl: string): Promise<string> {
        return new Promise((resolve, reject) => {
            var downloadedImg = new Image();
            downloadedImg.crossOrigin = "anonymous";
            downloadedImg.src = imageUrl;
    
            downloadedImg.onload = () => {
                var canvas = document.createElement("canvas");
                canvas.width = downloadedImg.width;
                canvas.height = downloadedImg.height;
                var ctx = canvas.getContext("2d");
                ctx.drawImage(downloadedImg, 0, 0, canvas.width, canvas.height);
                resolve(canvas.toDataURL());
            };
    
            downloadedImg.onerror = (error) => {
                reject(new Error("Error on loading image: " + imageUrl));
            };
        });
    }

    DeleteAnnotatedImage(annotatedImageIndex: number){
        this.savingCI = true;
        let ciAnnotatedImage = this.images[this.currentIndex].relatedImages[annotatedImageIndex];
        this._clearanceItemImageService.patchImageMarkAsDeleted(ciAnnotatedImage)
            .subscribe(img => {
                this.enableActionButtons=false;
                this._notificationsService.add(new Notification('success', 'Annotated Image was deleted successfully'));
                this.onDeleteAnnotatedImage.emit({image:this.images[this.currentIndex], annotatedImageIndex:annotatedImageIndex});
                this.savingCI=false;
            },
        (error: any) => {
            var e = JSON.stringify(error);
            if(e.indexOf("AntiXssMiddleware") !== -1 || error.includes("AntiXssMiddleware")){
              this._notificationsService.add(new Notification('error', this._errorHandler.xssMessage));                     
            }else{
              this._errorHandler.processError(error);
            }
            this.savingCI=false;
            console.error(error);
        } );
    }

    DeleteMainImage(imageIndex: number){
        this.savingCI = true;
        let ciImage = this.images[imageIndex];
        this._clearanceItemImageService.patchImageMarkAsDeleted(ciImage)
            .subscribe(img => {
                this.enableActionButtons=false;
                this._notificationsService.add(new Notification('success', 'Image and related images were deleted successfully'));
                this.onDeleteMainImage.emit(imageIndex);
                this.images.splice(imageIndex,1);
                if (this.images.length>0){
                    this.currentIndex = imageIndex === 0 ? this.currentIndex : this.currentIndex - 1;
                    this.setCurrentImageUrl();
                    this.setCurrentRelatedImages();
                }
                else{
                    this.closeModal('image-modal-carousel');
                }
                this.savingCI=false;
            },
        (error: any) => {
            var e = JSON.stringify(error);
            if(e.indexOf("AntiXssMiddleware") !== -1 || error.includes("AntiXssMiddleware")){
              this._notificationsService.add(new Notification('error', this._errorHandler.xssMessage));                     
            }else{
              this._errorHandler.processError(error);
            }
            this.savingCI=false;
            console.error(error);
        } );
    }

    preloadAndSetImage(originalSizeImageUrl: string) {
        const newImageKey = this.setNewImageKey();
        this.displayRetrievingImage=true;
        fetch(originalSizeImageUrl)
            .then(response => response.blob())
            .then(blob => {
                if (this.currentImageKey !== newImageKey){
                    console.log("Image loaded but canceled.");
                    this.displayRetrievingImage=false;
                    return;
                }
                const objectUrl = URL.createObjectURL(blob);
                this.currentFullImageUrl = this.domSanitizer.bypassSecurityTrustUrl(objectUrl); 
                this.displayRetrievingImage=false;
            })
            .catch(error => console.error('Error loading image:', error));
    }

    setNewImageKey(): string{
        const newImageKey = Math.random().toString(36); 
        this.currentImageKey = newImageKey;
        return newImageKey;

    }
}       


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/clearance-item/carousel.component.ts